import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/ui/Toast';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
    },
  },
});

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { err: Error | null }> {
  state = { err: null as Error | null };
  static getDerivedStateFromError(err: Error) { return { err }; }
  componentDidCatch(err: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', err, info);
    import('./main').then((m) =>
      m.reportClientError(`boundary: ${err?.message || err}`, (err?.stack || '') + '\n--componentStack--' + (info?.componentStack || ''))
    ).catch(() => {});
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui', color: '#fff', background: '#17212b', minHeight: '100vh' }}>
          <h2 style={{ color: '#e74c3c' }}>UI помилка</h2>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 13, background: '#232e3c', padding: 12, borderRadius: 8 }}>
            {String(this.state.err?.stack || this.state.err?.message || this.state.err)}
          </pre>
          <button onClick={() => location.reload()} style={{ padding: '8px 16px', background: '#6ab3f3', color: '#000', border: 0, borderRadius: 6, marginTop: 12 }}>
            Перезавантажити
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
